export default __webpack_public_path__ + "static/media/MEDITAZIONE_ICONA.537b21e4.svg";